import jwt from 'jwt-decode'
import { useEffect, useState } from "react";
import { useAuth } from '@clerk/clerk-react';

/**
 * Normalize Clerk org role by stripping the 'org:' prefix.
 * Clerk changed from 'admin' to 'org:admin' (and 'basic_member' to 'org:basic_member').
 * We compare using the unprefixed form for backward compatibility.
 */
export function normalizeClerkRole(role: string | null | undefined): string | undefined {
  if (role == null) return undefined;
  if (typeof role === 'string' && role.startsWith('org:')) {
    return role.slice(4);
  }
  return role;
}

export const useJwt = (token = false) => {
    const { getToken } = useAuth();
    const [JWTData, setJWtJson] = useState({})
    const [tokenLoaded, setTokenLoaded] = useState(false);
    useEffect(() => {
        const gteJWT = async () => {
            // const token: string | null = await getToken({ template: 'main' });
            // const data: string = jwt(token ?? "");
            // setJWtJson(data)
            // setTokenLoaded(true);

            try {
                const token: string | null = await getToken({ template: 'main' });
                // Only decode if we have a valid token
                if (token && token.trim() !== '') {
                    const data: any = jwt(token);
                    // Normalize org_role: Clerk now returns "org:admin" instead of "admin"
                    if (data && typeof data.org_role === 'string') {
                      data.org_role = normalizeClerkRole(data.org_role) ?? data.org_role;
                    }
                    setJWtJson(data);
                } else {
                    // Set empty object if no valid token
                    setJWtJson({});
                }
                setTokenLoaded(true);
            } catch (error) {
                console.warn('JWT decode error:', error);
                setJWtJson({});
                setTokenLoaded(true);
            }
        }

        gteJWT();
    }, [getToken])

    if(token) {
        return {
            JWTData,
            tokenLoaded
        };
    } 

    return JWTData;
}